import React, {useState, useContext} from 'react';
import styles from './Friend.module.sass';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EditIcon from '@mui/icons-material/Edit';
import Avatar from 'react-avatar';
import { shortenString } from '../../helper';
import cn from 'classnames';
import UserPhoto from '../UserPhoto';
import { ConquerContext } from '../../contexts/ConquerContext';
import { UserContext } from '../../contexts/UserContext';
import Loader from '../LoaderCircle';
import RemoveFriendModal from '../../screens/Friends/RemoveFriendModal';
import { FRIEND_STATUS } from '../../../Models/ENUM';

const FriendItem = ({ data ,onClick, id, onFriendAccept, onFriendRemoved, simple, isSelected }) => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );
    const [status, setStatus] = useState( data.status );
    const [isLoading, setIsLoading ]= useState( false );

    let avatar = data.avatarInstance;
    
    const state={
        name: 'Leo',
        avatar: '/images/content/avatar-0.jpg',
        time: '', //
        lastMsg: '',
        isTyping: false,
        // state: "3",
        isActive: false,
        selected: false,
    };

    let isInvited = status == FRIEND_STATUS.INVITED;
    let isPending = status == FRIEND_STATUS.PENDING;
    let isFriend = status == FRIEND_STATUS.ACCEPTED || status == FRIEND_STATUS.ACTIVE;
    let notAFriend = status == FRIEND_STATUS.UKNOWN;

    async function tryToAccept(){

        if( !isPending ) return;

        if ( !userContext.userData.isLogged ) return;

        setIsLoading( true );
        let response = await conquer.Friends.change( data.avatarID );
        console.log( 'ACCEPT RESPONSE', response );
        setIsLoading( false );

        if( response.success ) setStatus( FRIEND_STATUS.ACCEPTED);

    }

    async function tryToInvite(){

        setIsLoading( true );
        let response = await conquer.Friends.set( data.avatarID );
        setIsLoading( false );
        console.log('INVITE RESPONSE:', response);
        if( response.error ) return console.log('ERROR', response.error);
        setStatus( FRIEND_STATUS.INVITED );

    }

    return (
        <div className={cn(styles.friendItem, isSelected && styles.active, isInvited ? styles.Invited : '', simple && styles.simple)} onClick={() => { onClick?.(data) }}>
            <div className={styles.container}>

                <div className={styles.avatar}>
                    <UserPhoto data={data} />
                    {state.isActive && <div className={styles.active}/>}
                </div>

                {
                   !simple && <div className={styles.infoContainer}>
                        <div className={styles.friendState}>

                            <div className={styles.friendState__friendName}>{shortenString((avatar.firstName + ' ' + avatar.lastName) || '', 13)}</div>
                            {state.isTyping ? (
                                <div className={styles.friendState__typingIndicator}>
                                    <EditIcon
                                        className={
                                            styles.friendState__typingIndicator__editIcon
                                        }
                                    />
                                    <span>{state.name + ' is typing...'}</span>
                                </div>
                            ) : (
                                state.lastMsg && <div className={styles.friendState__lastMsg}>{state.lastMsg}</div>
                            )}
                        </div>

                        <div className={styles.msgState}>
                            {
                                isLoading ? <Loader/> :
                                <>
                                    { isFriend && <div className={styles.msgState__time}>{state.time}</div>}
                                    { isInvited && <div className={styles.status}>Invited</div> }
                                    { isPending && <button className={cn('button small')} onClick={tryToAccept}>Accept</button> }
                                    {/* { isFriend && <RemoveFriendModal friend={data} onFriendRemoved={onFriendRemoved}/> } */}
                                    { notAFriend && <button className={cn('button small')} onClick={tryToInvite}>ADD</button> }
                                </>
                            }

                            
                            {/* Ignore bade  */}
                            {/* 
                            {state.state === 'check' && (
                                <CheckIcon
                                    className={styles.msgState__check}></CheckIcon>
                            )}
                            {state.state === 'doublecheck' && (
                                <DoneAllIcon
                                    className={styles.msgState__check}></DoneAllIcon>
                            )}
                            {state.state !== 'doublecheck' &&
                                state.state !== 'check' && (
                                    <div className={styles.msgState__unread}>
                                        {state.state}
                                    </div>
                                )} */}
                        </div>
                    </div>
                }


            </div>
        </div>
    );
};

export default FriendItem;
